import api from './api';

const accessRequestService = {
  createForCompany: (companyId, requestedDurationMinutes) =>
    api.post(`/companies/${companyId}/access-requests`, { requestedDurationMinutes }),
  getById: (id) => api.get(`/access-requests/${id}`),
  accept: (id) => api.post(`/access-requests/${id}/accept`),
  reject: (id) => api.post(`/access-requests/${id}/reject`),
  cancel: (id) => api.post(`/access-requests/${id}/cancel`),
  cancelAllPending: () => api.post('/access-requests/cancel-pending'),
  closeSession: (companyId, requestId) =>
    api.post(`/companies/${companyId}/access-requests/${requestId}/close-session`),
};

export default accessRequestService;
